var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';
export default function ArrowRightIcon(_a) {
    var { size = 'xsmall' } = _a, rest = __rest(_a, ["size"]);
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        } }, rest),
        jsx("path", { transform: "rotate(180 10 10)", fill: "currentColor", fillRule: "evenodd", d: "M.146 9.146l4-4a.5.5 0 01.707.707L1.707 9H19.5a.5.5 0 110 1H1.707l3.146 3.146a.5.5 0 01-.707.707l-4-4a.5.5 0 010-.707" })));
}
//# sourceMappingURL=ArrowRightIcon.js.map